import { BsFiles } from '@react-icons/all-files/bs/BsFiles';
import { BsLayoutTextSidebar } from '@react-icons/all-files/bs/BsLayoutTextSidebar';
import { BsPeople } from '@react-icons/all-files/bs/BsPeople';
import React from 'react';
import Steps from '../../components/Steps';
import Step from '../../components/Steps/Step';

const Title = () => (
  <>
    How Google Drive Audit <span className="text-indigo-600">works?</span>
  </>
);

const HowItWorks = () => {
  return (
    <Steps video="https://www.youtube.com/embed/f7ojczgypiA" title={<Title />}>
      <Step Icon={BsLayoutTextSidebar} step="Step 1">
        Install the add-on in your Google account and authorize it to access
        your Google Drive.
      </Step>
      <Step Icon={BsPeople} step="Step 2">
        Specify your Drive search query and all the matching file and folders in
        your Google Drive will be audited for sharing access and permissions.
      </Step>
      <Step Icon={BsFiles} step="Step 3" isLastStep>
        Start the audit and the report will be generated in a new workbook
        (sheet) in your Google Spreadsheet.
      </Step>
    </Steps>
  );
};

export default HowItWorks;
